$( function() {
	$( window ).click( function( event ) {
		if ( !$( event.target ).closest( '.dropdown-button' ).length ) {
			$( '.dropdown-area' ).slideUp( 'fast' );
		}
	} );

	$( '.dropdown' ).each( function() {
		var $dropdown = $( this );
		$( '.dropdown-button', $dropdown ).click( function( event ) {
			event.preventDefault();
			$( '.dropdown-area', $dropdown ).slideToggle( 'fast' );
			var $this = $( this );

			var $option = $this.find( 'option:selected' );
			var $target = $( $this.attr( 'data-tabs-target' ) );

			var tabIndex = $option.attr( 'data-tab-target-index' );
			if ( tabIndex >= 0 ) {
				$target.find( '.tab' )
					.removeClass( 'active' )
					.eq( tabIndex )
					.addClass( 'active' );
			}
		} );
		$( '.dropdown-item', $dropdown ).click( function() {
			var clickedItem = this;
			var $clickedItem = $( this );
			$( '.dropdown-item', $dropdown ).each( function() {
				var isClickedItem = this === clickedItem;
				$( this )
					.toggleClass( '!text-light-blue', isClickedItem )
					.toggleClass( '!text-nrp-blue', !isClickedItem );
			} );
			$( '.dropdown-label', $dropdown ).html( $( this ).html() );

			var $target = $( $clickedItem.attr( 'data-tabs-target' ) );
			var tabIndex = $clickedItem.attr( 'data-tab-target-index' );
			if ( tabIndex >= 0 ) {
				$target.find( '.tab' )
					.removeClass( 'active' )
					.eq( tabIndex )
					.addClass( 'active' );
			}
		} );
	} );
} );
